"use client";

import { useEffect } from "react";

import { isLocalhost } from "@workspace/utils/environment";

import { subscribeToRouteChanges } from "./route-changes";
import type { TrackingWindow } from "./window";

const METRICOOL_HASH = "695b3c946ef80ab745eb65706075ad74";
const SCRIPT_ID = "metricool-be-tracker";
const SCRIPT_SRC = "https://tracker.metricool.com/resources/be.js";

let scriptLoadPromise: Promise<void> | undefined;

function loadMetricoolScript() {
  scriptLoadPromise ??= new Promise((resolve) => {
    if (document.getElementById(SCRIPT_ID)) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.type = "text/javascript";
    script.src = SCRIPT_SRC;
    script.onload = () => resolve();
    document.head.appendChild(script);
  });

  return scriptLoadPromise;
}

function trackPageView() {
  (window as unknown as TrackingWindow).beTracker?.t({ hash: METRICOOL_HASH });
}

export const MetricoolAnalytics = () => {
  useEffect(() => {
    if (isLocalhost()) return;

    let unsubscribe: VoidFunction | undefined;

    void loadMetricoolScript().then(() => {
      trackPageView();
      unsubscribe = subscribeToRouteChanges(trackPageView);
    });

    return () => unsubscribe?.();
  }, []);

  return null;
};
